import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTimes } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';

const SUPPORT_LEVEL_OPTIONS = [
  { value: '0', label: 'Sin nivel asignado' },
  { value: '1', label: 'Nivel 1 - Básico' },
  { value: '2', label: 'Nivel 2 - Avanzado' },
  { value: '3', label: 'Nivel 3 - Ingeniería' },
  { value: '4', label: 'Nivel 4 - Externo' }
];

const NivelFilterSelect = ({
  selectedNivelId,
  onSelectNivel
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const isSelected = selectedNivelId !== '' && selectedNivelId !== null && selectedNivelId !== undefined;

  return (
    <div className="d-flex align-items-center gap-2 se-nivel-filter-container position-relative">
      <label
        htmlFor="tickets-nivel-filter-select"
        className="d-flex align-items-center gap-1 text-600 mb-0 fw-semibold"
        style={{ fontSize: '0.80rem', whiteSpace: 'nowrap' }}
      >
        <FontAwesomeIcon
          icon={faLayerGroup}
          style={{ color: isSelected ? (isDark ? '#60a5fa' : '#2563eb') : (isDark ? '#94a3b8' : '#64748b') }}
        />
        <span>Nivel:</span>
      </label>

      <div className="position-relative d-inline-flex align-items-center">
        <select
          id="tickets-nivel-filter-select"
          className="form-select form-select-sm border shadow-none text-900 fw-semibold"
          style={{
            fontSize: '0.82rem',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: isDark ? '#1e293b' : '#f8fafc',
            borderColor: isSelected ? (isDark ? '#2563eb' : '#60a5fa') : (isDark ? '#233142' : '#e2e8f0'),
            color: isDark ? '#f8fafc' : '#334155',
            paddingRight: isSelected ? '32px' : undefined,
            minWidth: '150px',
            maxWidth: '200px'
          }}
          value={selectedNivelId !== null && selectedNivelId !== undefined ? String(selectedNivelId) : ''}
          onChange={e => onSelectNivel(e.target.value)}
          title="Filtrar tickets por nivel de soporte"
        >
          <option value="">Todos los niveles</option>
          {SUPPORT_LEVEL_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {isSelected && (
          <button
            type="button"
            className="btn btn-link position-absolute p-0 text-muted border-0 shadow-none"
            style={{
              right: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '0.70rem',
              lineHeight: 1
            }}
            onClick={() => onSelectNivel('')}
            title="Quitar filtro de nivel"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>
    </div>
  );
};

export default NivelFilterSelect;
